export default __webpack_public_path__ + "static/benefitImage1-aa67f143cfe9332ddd13c7cf0b3bce8e.webp";